/** Estilos compartidos de Reuniones (móvil primero; escritorio 2 columnas media-first). */

export const meetingPageShellSx = (contentMargin) => ({
  display: "flex",
  flexDirection: "column",
  height: "100dvh",
  maxHeight: "100dvh",
  boxSizing: "border-box",
  overflowX: "hidden",
  overflowY: "auto",
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  pt: { xs: 1, md: 1.5 },
  px: { xs: 1, sm: 1.5, md: 2, lg: 2.5 },
  pb: { xs: 11, md: 2.5 },
  ...contentMargin,
  alignItems: "stretch",
  // Cabecera / avisos no deben comprimirse bajo el flex del shell
  "& > *": { minHeight: "auto" },
});

export const meetingSectionGap = 2;

/**
 * xs: 1 col · md+: 2 cols (app | media+acta)
 */
export const meetingDesktopSplitSx = {
  display: "grid",
  gap: { xs: 2, md: 2, lg: 2.25 },
  alignItems: "start",
  width: "100%",
  gridTemplateColumns: {
    xs: "1fr",
    md: "minmax(280px, 340px) minmax(0, 1fr)",
    lg: "minmax(280px, 360px) minmax(0, 1fr)",
    xl: "minmax(300px, 380px) minmax(0, 1fr)",
  },
};

export const meetingDesktopAsideSx = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  minWidth: 0,
  position: { md: "sticky" },
  top: { md: 76 },
  alignSelf: "start",
  maxHeight: { md: "calc(100dvh - 88px)" },
  overflowY: { md: "auto" },
  // Evita que overflow recorte el borde/sombra del último card (Datos reunión)
  pb: { md: 1.5 },
  boxSizing: "border-box",
  gridColumn: { xs: "1", md: "1" },
};

export const meetingDesktopMainSx = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  minWidth: 0,
  gridColumn: { xs: "1", md: "2" },
};

/** Cabecera de sesión fija al hacer scroll (dentro del shell). */
export const meetingStickyHeaderSx = (theme) => ({
  position: "sticky",
  top: 0,
  zIndex: 30,
  mb: meetingSectionGap,
  // pageHeroShellSx pone overflow:hidden y rompe sticky
  overflow: "visible",
  bgcolor:
    theme.palette.mode === "dark"
      ? "rgba(18,18,18,0.97)"
      : "rgba(255,255,255,0.97)",
  backdropFilter: "blur(10px)",
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 8px 20px rgba(0,0,0,0.4)"
      : "0 8px 20px rgba(15,23,42,0.08)",
});

/** Feed media-first: pastillas 2 en 2. */
export const meetingMediaFeedSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(0, 1fr))",
  },
  gap: { xs: 1.25, md: 1.35 },
  alignItems: "stretch",
};

/** Miniatura fija cuadrada (compacta) en el feed. */
export const meetingMediaThumbFrameSx = {
  position: "relative",
  width: "100%",
  aspectRatio: "1 / 1",
  flex: "0 0 auto",
  borderRadius: 2,
  overflow: "hidden",
  bgcolor: "grey.900",
};

/** Media rellenando la caja (cover). */
export const meetingMediaThumbMediaSx = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
};

/** @deprecated */
export const meetingMediaThumbSx = {
  ...meetingMediaThumbFrameSx,
};

export const meetingMediaFeedCardSx = (theme, highlighted) => ({
  display: "grid",
  gridTemplateColumns: {
    xs: "88px minmax(0, 1fr)",
    sm: "96px minmax(0, 1fr)",
    md: "104px minmax(0, 1fr)",
  },
  gap: { xs: 1, md: 1.15 },
  alignItems: "start",
  minWidth: 0,
  height: "100%",
  p: { xs: 1, md: 1.1 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: highlighted ? "primary.main" : "divider",
  bgcolor:
    theme.palette.mode === "dark"
      ? "rgba(18,18,18,0.92)"
      : "rgba(255,255,255,0.98)",
  outline: highlighted ? "2px solid" : "none",
  outlineColor: highlighted ? "primary.main" : "transparent",
  outlineOffset: 1,
  transition: "border-color 0.2s, outline-color 0.2s",
});

/** Pastilla de media en grupos: thumb + contenido, sin columna de handle. */
export const meetingMediaGroupCardSx = (theme, highlighted) => ({
  display: "grid",
  gridTemplateColumns: {
    xs: "92px minmax(0, 1fr)",
    sm: "108px minmax(0, 1fr)",
  },
  gap: { xs: 1.25, sm: 1.5 },
  alignItems: "start",
  minWidth: 0,
  width: "100%",
  boxSizing: "border-box",
  p: { xs: 1.1, sm: 1.25 },
  borderRadius: 2.5,
  border: "1px solid",
  borderColor: highlighted
    ? "primary.main"
    : theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.08)"
      : "rgba(15,23,42,0.08)",
  bgcolor: theme.palette.mode === "dark" ? "rgba(24,24,24,0.95)" : "#fff",
  boxShadow: highlighted
    ? `0 0 0 1px ${theme.palette.primary.main}`
    : theme.palette.mode === "dark"
      ? "0 1px 0 rgba(255,255,255,0.04)"
      : "0 1px 2px rgba(15,23,42,0.04)",
  transition:
    "border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease",
  "&:hover": {
    borderColor: highlighted ? "primary.main" : "primary.light",
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 8px 24px rgba(0,0,0,0.35)"
        : "0 8px 20px rgba(15,23,42,0.08)",
  },
});

/** Feed de grupos: 1 col móvil; 2 cols en pantallas anchas. */
export const meetingMediaGroupsFeedSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    lg: "repeat(2, minmax(0, 1fr))",
  },
  gap: { xs: 1.25, md: 1.35 },
  alignItems: "stretch",
};

/** Bandeja de grupos abiertos (inline sticky o embebida en columna izquierda). */
export const meetingEmptyGroupsDockSx = (theme, { sticky = true } = {}) => ({
  position: sticky ? "sticky" : "relative",
  top: sticky ? { xs: 108, sm: 116 } : undefined,
  zIndex: sticky ? 25 : 2,
  mb: 1.5,
  p: 1,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "primary.light",
  bgcolor:
    theme.palette.mode === "dark"
      ? "rgba(18,18,18,0.96)"
      : "rgba(255,255,255,0.97)",
  backdropFilter: sticky ? "blur(10px)" : undefined,
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 10px 24px rgba(0,0,0,0.45)"
      : "0 10px 24px rgba(15,23,42,0.12)",
});

/** @deprecated 3ª columna eliminada; se mantiene por si hay imports residuales. */
export const meetingDesktopSummarySx = {
  display: "none",
};

export const meetingActionBtnSx = {
  width: "100%",
  minHeight: { xs: 52, md: 48 },
  px: 2,
  fontWeight: 700,
  textTransform: "none",
  borderRadius: 2.5,
  fontSize: { xs: "1rem", md: "0.95rem" },
};

/** Toolbar de cabecera de sesión: misma altura y look. */
export const MEETING_HEADER_BTN_HEIGHT = 36;

export const meetingHeaderToolbarSx = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: 0.75,
  minWidth: 0,
};

export const meetingHeaderBtnSx = {
  height: MEETING_HEADER_BTN_HEIGHT,
  minHeight: MEETING_HEADER_BTN_HEIGHT,
  maxHeight: MEETING_HEADER_BTN_HEIGHT,
  px: 1.25,
  py: 0,
  borderRadius: 2,
  textTransform: "none",
  fontWeight: 700,
  fontSize: "0.8125rem",
  lineHeight: 1.2,
  whiteSpace: "nowrap",
  boxShadow: "none",
  "& .MuiButton-startIcon": {
    marginRight: 0.6,
    marginLeft: -0.25,
    "& > *:nth-of-type(1)": { fontSize: "1.05rem" },
  },
  "&.Mui-disabled": {
    opacity: 0.48,
  },
};

export const meetingHeaderToggleSx = {
  height: MEETING_HEADER_BTN_HEIGHT,
  minHeight: MEETING_HEADER_BTN_HEIGHT,
  borderRadius: 2,
  overflow: "hidden",
  "& .MuiToggleButton-root": {
    height: MEETING_HEADER_BTN_HEIGHT,
    minHeight: MEETING_HEADER_BTN_HEIGHT,
    px: 1.25,
    py: 0,
    fontWeight: 800,
    fontSize: "0.75rem",
    lineHeight: 1,
    textTransform: "none",
    border: "1px solid",
    borderColor: "divider",
  },
};

export const meetingHeaderIconBtnSx = {
  width: MEETING_HEADER_BTN_HEIGHT,
  height: MEETING_HEADER_BTN_HEIGHT,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
};

export const meetingChipRowSx = {
  display: "flex",
  flexWrap: "wrap",
  gap: 0.75,
  alignItems: "center",
  pt: 0.25,
  pb: 0.15,
};

/** Grid denso legacy (captura rápida sin notas). */
export const meetingGalleryGridSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "repeat(2, minmax(0, 1fr))",
    sm: "repeat(3, minmax(0, 1fr))",
    md: "repeat(auto-fill, minmax(120px, 1fr))",
    lg: "repeat(auto-fill, minmax(128px, 1fr))",
    xl: "repeat(auto-fill, minmax(140px, 1fr))",
  },
  gap: { xs: 1.25, md: 1.25 },
};

export const meetingCaptureCardSx = (theme) => ({
  p: { xs: 1.75, sm: 2, md: 2 },
  borderRadius: 3,
  border: "1px solid",
  borderColor: "divider",
  bgcolor:
    theme.palette.mode === "dark"
      ? "rgba(18,18,18,0.92)"
      : "rgba(255,255,255,0.98)",
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 8px 28px rgba(0,0,0,0.35)"
      : "0 8px 24px rgba(15,23,42,0.08)",
});

export const meetingAutocompleteSx = {
  width: "100%",
  minWidth: 0,
  "& .MuiAutocomplete-inputRoot": {
    flexWrap: "wrap",
    rowGap: 0.5,
  },
  "& .MuiAutocomplete-tag": {
    maxWidth: "calc(100% - 8px)",
    height: 28,
  },
  "& .MuiChip-label": {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "& .MuiFormControl-root": {
    minWidth: 0,
  },
  "& .MuiOutlinedInput-root": {
    alignItems: "flex-start",
    py: 0.5,
  },
};

/** Listado: lista + preview en escritorio. */
export const meetingListSplitSx = {
  display: "grid",
  gap: 2,
  alignItems: "start",
  width: "100%",
  gridTemplateColumns: {
    xs: "1fr",
    md: "minmax(260px, 340px) minmax(0, 1fr)",
  },
  minHeight: { md: "calc(100dvh - 200px)" },
};

export const meetingListPaneSx = {
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: 0.25,
  maxHeight: { md: "calc(100dvh - 180px)" },
  overflowY: { md: "auto" },
  boxSizing: "border-box",
};

export const meetingPreviewPaneSx = {
  minWidth: 0,
  position: { md: "sticky" },
  top: { md: 12 },
  alignSelf: "start",
  maxHeight: { md: "calc(100dvh - 180px)" },
  overflowY: { md: "auto" },
};
